import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms"

export function whiteSpaceValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        if(control.value) {
            return control.value.trim().length !== 0 ? null : { 'required': true }
        }
        return null
    }
  }